/** Shared client-side upload validation (feature 3).
 *
 * Mirrors GET /documents/upload-config (the backend's settings-driven limits);
 * when the config hasn't loaded (or the request failed) it falls back to the
 * backend's documented defaults so the UI never blocks a valid upload on a
 * transient config fetch error. Returns { valid, errors } keyed by filename.
 */
const FALLBACK_MAX = 50 * 1024 * 1024; // backend MAX_UPLOAD_SIZE default
const FALLBACK_EXTS = ["pdf"];

export function uploadMaxBytes(cfg) {
  return cfg && Number(cfg.max_upload_size) > 0 ? Number(cfg.max_upload_size) : FALLBACK_MAX;
}

export function uploadAllowedExtensions(cfg) {
  const exts = cfg && Array.isArray(cfg.allowed_extensions) ? cfg.allowed_extensions : FALLBACK_EXTS;
  return exts.map((e) => String(e).toLowerCase().replace(/^\./, ""));
}

export function uploadAcceptAttribute(cfg) {
  return uploadAllowedExtensions(cfg).map((e) => `.${e}`).join(",");
}

export function validateUploadFiles(files, cfg) {
  const max = uploadMaxBytes(cfg);
  const extensions = uploadAllowedExtensions(cfg);
  const valid = [];
  const errors = {};
  for (const f of files) {
    const ext = (f.name.split(".").pop() || "").toLowerCase();
    if (!extensions.includes(ext)) {
      errors[f.name] = `Unsupported file type (.${ext || "none"})`;
    } else if (f.size > max) {
      errors[f.name] = `Too large (max ${Math.floor(max / (1024 * 1024))} MB)`;
    } else {
      valid.push(f);
    }
  }
  return { valid, errors };
}